"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CardFooter_component_exports = {};
__export(CardFooter_component_exports, {
  CardFooter: () => CardFooter,
  default: () => CardFooter_component_default
});
module.exports = __toCommonJS(CardFooter_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var _excluded = ["children"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var CardFooter = function CardFooter2(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, props, /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, null, children));
};
var CardFooter_component_default = CardFooter;
var _StyledDiv = (0, import_styled_components.default)("div")({
  "marginLeft": "1rem",
  "marginRight": "1rem",
  "display": "flex",
  "height": "100%",
  "minHeight": "72px",
  "alignItems": "center",
  "alignSelf": "flex-end"
});
var _StyledDiv2 = (0, import_styled_components.default)("div").withConfig({
  displayName: "CardFootercomponent___StyledDiv2",
  componentId: "sc-1aplaq6-0"
})({
  "display": "flex",
  "gap": "0.5rem"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardFooter
});
//# sourceMappingURL=CardFooter.component.js.map